import React from 'react';

import * as S from './AvailBenifitModal.styles';

const AvailBenifitModal = ({
  heading,
  listData,
  closeBtn,
  onClose,
}) => {
  return (
    <React.Fragment>
      <S.BenifitMdlCont>
        <S.BenifitMdlHdr>
          {heading && <S.BenifitMdlHdng>{heading}</S.BenifitMdlHdng>}
          {closeBtn && <S.BenifitMdlClose onClick={onClose}></S.BenifitMdlClose>}
        </S.BenifitMdlHdr>
        <S.BenifitMdlBody>
          {
            listData && listData.length > 0 &&
            <S.BenifitMdlList>
              {
                listData.map((item, index) => (
                  <li key={index}>{item}</li>
                ))
              }
            </S.BenifitMdlList>
          }
        </S.BenifitMdlBody>
      </S.BenifitMdlCont>
      <S.BenifitMdlBackdrop onClick={onClose} />
    </React.Fragment>
  )
}

export default AvailBenifitModal;